import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { Gavel, History, Home, Plus, Scale, Settings, User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export function Layout() {
  const { profile, signOut } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="app-shell">
      <header className="topbar glass">
        <button className="brand" onClick={() => navigate('/')} aria-label="Vai alla home">
          <span className="brand-icon"><Gavel size={20} /></span>
          <span>Aste Euroleghe</span>
        </button>
        <div className="topbar-actions">
          <span className="user-chip">{profile?.display_name || profile?.nickname || 'Profilo'}</span>
          <button className="ghost-button" onClick={signOut}>Esci</button>
        </div>
      </header>

      <main className="content">
        <Outlet />
      </main>

      <nav className="bottom-nav glass" aria-label="Navigazione principale">
        <NavLink to="/" end><Home size={20} /><span>Home</span></NavLink>
        <NavLink to="/auctions/new"><Plus size={20} /><span>Crea</span></NavLink>
        <NavLink to="/history"><History size={20} /><span>Storico</span></NavLink>
        <NavLink to="/judge"><Scale size={20} /><span>Giudice</span></NavLink>
        <NavLink to="/profile"><User size={20} /><span>Profilo</span></NavLink>
        <NavLink to="/settings"><Settings size={20} /><span>Impost.</span></NavLink>
      </nav>
    </div>
  );
}
